import React from "react";
import { useDispatch } from "react-redux";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsStrings from "../../../constants/ConstantsStrings";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import WidgetTooltipWrapper from "../widget-tooltip-wrapper/WidgetTooltipWrapper";
import ConstantsTexts from "../../../constants/ConstantsTexts";

const WidgetUsersIcon = () => {
  const dispatch = useDispatch();

  const handleUsersIconClick = () => {
    dispatch({ type: ConstantsStrings.OPEN_USERS_DIALOG });
  };

  return (
    <WidgetTooltipWrapper content={ConstantsTexts.CODE_214}>
      <WidgetIcon
        iconProp={ConstantsImages.ACCOUNT_IMAGE}
        widthIconProp="1.7rem"
        heightIconProp="1.7rem"
        backgroundColorProp="#2e2e2e"
        handleOnClickProp={handleUsersIconClick}
        customClassNameProp="widget-users-icon"
      />
    </WidgetTooltipWrapper>
  );
};

export default WidgetUsersIcon;
